/**
 The MIT License

 Copyright (c) 2010 Daniel Park (http://metaweb.com, http://postmessage.freebaseapps.com)

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 **/

const _CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');

const defaultOptions = {
    target: null /* target window (required) */,
    url: null /* target window url (required if no window.postMessage or hash == true) */,
    type: null /* message type (required) */,
    data: null /* message data (required) */,
    success: null /* success callback (optional) */,
    error: null /* error callback (optional) */,
    origin: '*' /* postmessage origin (optional) */,
    hash: false /* use location hash for message passing (optional) */
};

const _data = {};

const _random = function() {
    const r = [];
    for (let i = 0; i < 32; i++) {
        r[i] = _CHARS[0 | (Math.random() * 32)];
    }
    return r.join('');
};

const _sendReply = function(data, e, msg) {
    if (msg.callback) {
        send({target: e.source, data: data, type: msg.callback});
    }
};

const _dispatch = function(e) {
    try {
        var msg = JSON.parse(e.data);
    } catch (ex) {
        window.console.warn('postmessage data invalid json: ', ex, e.data);
        return;
    }
    if (!msg.type) {
        window.console.warn('postmessage message type required');
        return;
    }
    var cbs = data('callbacks.postmessage') || {},
        cb = cbs[msg.type];
    if (cb) {
        cb(msg.data);
    } else {
        const l = data('listeners.postmessage') || {},
            fns = l[msg.type] || [];

        for (let i = 0, len = fns.length; i < len; i++) {
            var o = fns[i];
            if (o.origin && o.origin !== '*' && e.origin !== o.origin) {
                window.console.warn('postmessage message origin mismatch', e.origin, o.origin);
                if (msg.errback) {
                    // notify post message errback
                    const error = {
                        message: 'postmessage origin mismatch',
                        origin: [e.origin, o.origin]
                    };
                    send({target: e.source, data: error, type: msg.errback});
                }
                continue;
            }

            try {
                if (o.callback) {
                    o.fn(msg.data, _sendReply(msg.data, e, msg), e);
                } else {
                    _sendReply(o.fn(msg.data, e), e, msg);
                }
            } catch (ex) {
                if (msg.errback) {
                    // notify post message errback
                    send({target: e.source, data: ex, type: msg.errback});
                } else {
                    throw ex;
                }
            }
        }
    }
};

const _bind = function() {
    // are we already listening to message events on this w?
    if (!data('listening.postmessage')) {
        if (window.addEventListener) {
            window.addEventListener('message', _dispatch, false);
        } else if (window.attachEvent) {
            window.attachEvent('onmessage', _dispatch);
        }
        data('listening.postmessage', 1);
    }
};

const _callback = function(fn) {
    var cbs = data('callbacks.postmessage');
    if (!cbs) {
        cbs = {};
        data('callbacks.postmessage', cbs);
    }
    var r = _random();
    cbs[r] = fn;
    return r;
};

const _replyBin = function(type, fn, origin, hash, isCallback) {
    if ('postMessage' in window && !hash) {
        _bind();
    }

    let l = data('listeners.postmessage');

    if (!l) {
        l = {};
        data('listeners.postmessage', l);
    }
    let fns = l[type];
    if (!fns) {
        fns = [];
        l[type] = fns;
    }
    fns.push({fn: fn, callback: isCallback, origin: origin});
};

const send = function(options) {
    const o = Object.assign({}, defaultOptions, options),
        target = o.target;
    if (!o.target) {
        window.console.warn('postmessage target window required');
        return;
    }
    if (!o.type) {
        window.console.warn('postmessage type required');
        return;
    }
    const msg = {data: o.data, type: o.type};
    if (o.success) {
        msg.callback = _callback(o.success);
    }
    if (o.error) {
        msg.errback = _callback(o.error);
    }
    if ('postMessage' in target && !o.hash) {
        _bind();
        target.postMessage(JSON.stringify(msg), o.origin || '*');
    }
};

const data = function(k, v) {
    if (v === undefined) {
        return _data[k];
    }
    _data[k] = v;
    return v;
};

const bind = function(type, fn, origin, hash, async_reply) {
    _replyBin(type, fn, origin, hash, async_reply);
};

const unbind = function(type, fn) {
    const l = data('listeners.postmessage');
    if (l) {
        if (type) {
            if (fn) {
                // remove specific listener
                var fns = l[type];
                if (fns) {
                    var m = [];
                    for (var i = 0, len = fns.length; i < len; i++) {
                        var o = fns[i];
                        if (o.fn !== fn) {
                            m.push(o);
                        }
                    }
                    l[type] = m;
                }
            } else {
                // remove all listeners by type
                delete l[type];
            }
        } else {
            // unbind all listeners of all type
            for (const i in l) {
                delete l[i];
            }
        }
    }
};

export default {
    send,
    bind,
    unbind,
    data,
    ...defaultOptions
};
